import { c as _c } from "react/compiler-runtime";
import { Card } from "@/components/ui/card";
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { cn } from "@/utils/helpers";
import { X } from "lucide-react";
import Image from "next/image";
type TestimonialCardProps = {
  imageUrl: string;
  className?: string;
};
export default function TestimonialCard(t0) {
  const $ = _c(14);
  const {
    imageUrl,
    className
  } = t0;
  if (!imageUrl) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cn("w-full cursor-pointer overflow-hidden bg-muted transition hover:border-green-400 hover:opacity-90", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== imageUrl) {
    t2 = <Image src={imageUrl} alt="Testimonial card image" width={400} height={200} className="w-full" />;
    $[2] = imageUrl;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <DialogTrigger><Card className={t1}>{t2}</Card></DialogTrigger>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="overflow-hidden"><DialogTitle>Testimonial</DialogTitle><DialogDescription /></div>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DialogHeader className="flex-row items-start">{t4}<DialogClose className="ml-auto"><X size={18} /></DialogClose></DialogHeader>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== imageUrl) {
    t6 = <DialogContent>{t5}<div className="relative aspect-video w-full overflow-hidden rounded-xl border bg-muted"><Image src={imageUrl} alt="Testimonial card image" fill={true} loading="eager" className="object-scale-down" /></div></DialogContent>;
    $[9] = imageUrl;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t6) {
    t7 = <Dialog>{t3}{t6}</Dialog>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}

// Recycled

// 15 Feb 2026

// const imageName = imageUrl.split("/").pop();